const setCurrentTokenValue = (state, currentTokenValue) => {
  state.currentTokenValue = currentTokenValue
}

export default {
  setCurrentTokenValue,
}
